import React from 'react'
import './style.scss'

export default ({ title="", children="" }) => 
    <div className="AutopagoModalText">
        <h3>{title}</h3>
        {children}
    </div>
